export enum SeriesProperties {
  Description = "description",
  Seasons = "seasons",
  Name = "name",
  Casting = "casting",
  TitleMediaUrl = "titleMediaUrl",
  TitleMediaImageUrl = "titleMediaImageUrl",
  ReleaseDate = "releaseDate",
  Owner = "owner",
  Id = "id",
  Created = "created",
  Updated = "updated",
  Deleted = "deleted",
  Version = "version",
  MediaStatus = "mediaStatus",
  TitleTransparentUrl = "titleTransparentUrl",
  Genre = "genre",
  Tags = "tags",
  TitleMediaImageLocation = "titleMediaImageLocation",
  TitleMediaLocation = "titleMediaLocation",
  TitleTransparentLocation = "titleTransparentLocation",
  HasProcessed = "hasProcessed",
  Rating = "rating"
}
export enum SeriesMetaProperties {
  SeasonsId = "Seasons-id",
  SeasonsVersion = "Seasons-version",
  CastingId = "Casting-id",
  CastingVersion = "Casting-version",
  GenreId = "Genre-id",
  GenreVersion = "Genre-version",
  TagsId = "Tags-id",
  TagsVersion = "Tags-version"
}
